/* eslint-disable react/prop-types */
import { Button, Popconfirm } from 'antd';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import DirectDiscountApi, {
  DISCOUNT_TYPE,
} from '../../functions/api/booking/DirectDiscountApi';
import MyUtil from '../../functions/MyUtil';

export default class ButtonFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      edit: false,
      directDiscountInfo: '',
    };

    this.toggle = this.toggle.bind(this);
  }

  handleChangeList = async () => {
    const { row } = this.props;
    await DirectDiscountApi.deleteDirectDiscount(row.id);
    const listDirectDiscount = await DirectDiscountApi.getAll();
    await this.props.onChangeList(listDirectDiscount);
  };

  handleEdit = () => {
    const { edit } = this.state;
    this.setState({
      edit: !edit,
    });
  };

  async toggle() {
    const { directDiscountInfo, modal } = this.state;
    const { row } = this.props;
    if (!directDiscountInfo) {
      const detail = await DirectDiscountApi.getById(row.id);
      this.setState({ directDiscountInfo: detail });
    }
    this.setState({
      modal: !modal,
    });
  }

  render() {
    const { directDiscountInfo, modal } = this.state;
    const directDiscount = directDiscountInfo[0];
    const { row, className } = this.props;
    const canEdit = MyUtil.hasPermission('/direct-discount', 'update');
    const canDelete = MyUtil.hasPermission('/direct-discount', 'delete');

    const linkEdit = `/direct-discount/edit/${row.id}`;
    const linkEditRecurring = `/direct-discount/edit-recurring/${row.id}`;

    return (
      <div className="div-edit">
        {canEdit && (
          <>
            <Link
              to={
                row.direct_discount_type_id === DISCOUNT_TYPE.DIRECT_DISCOUNT
                  ? linkEdit
                  : linkEditRecurring
              }
            >
              <Button size="small" onClick={() => this.handleEdit()}>
                <i className="fas fa-edit"></i>
              </Button>
            </Link>
          </>
        )}

        <Button
          size="small"
          style={{ marginLeft: '2px', marginRight: '2px' }}
          onClick={this.toggle}
        >
          <i className="fas fa-info"></i>
        </Button>

        {canDelete && (
          <Popconfirm
            title="Bạn chắc chắn muốn xóa?"
            onConfirm={() => this.handleChangeList()}
          >
            <Button size="small" danger>
              <i className="fas fa-trash"></i>
            </Button>
          </Popconfirm>
        )}

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          className={`${className} detail-vehicle`}
        >
          <ModalHeader toggle={this.toggle}>
            Chi tiết giảm giá trực tiếp
          </ModalHeader>
          {directDiscount && (
            <ModalBody style={{ fontSize: '16px' }}>
              <div className="title-detail-promotion">
                <b>Direct discount ID:</b>
              </div>
              <span>{directDiscount.id}</span>
              <br />

              <div className="title-detail-promotion">
                <b>Giá trị giảm:</b>
              </div>
              <span>
                {directDiscount.discount_value <= 100
                  ? `${directDiscount.discount_value} %`
                  : `${MyUtil.currencyFormat(
                      directDiscount.discount_value
                    )} vnđ`}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Giảm tối đa:</b>
              </div>
              <span>{`${MyUtil.currencyFormat(
                directDiscount.max_value
              )} vnđ`}</span>
              <br />

              <div className="title-detail-promotion">
                <b>Áp dụng cho thành phố:</b>
              </div>
              <span>
                {directDiscount.city_name
                  ? directDiscount.city_name
                  : 'Tất cả các thành phố'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Áp dụng cho dòng xe:</b>
              </div>
              <span>
                {directDiscount.vhc_slug
                  ? MyUtil.makeTitle(directDiscount.vhc_slug)
                  : 'Tất cả các dòng xe'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Áp dụng cho đối tác:</b>
              </div>
              <span>
                {directDiscount.part_name
                  ? directDiscount.part_name
                  : 'Tất cả đối tác'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Áp dụng cho xe của đối tác:</b>
              </div>
              <span>
                {directDiscount.vhc_part_name
                  ? directDiscount.vhc_part_name
                  : 'Tất cả xe của đối tác'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Thời gian áp dụng khuyến mãi:</b>
              </div>
              {isEmpty(directDiscount.day_discount) ? (
                <span>
                  {`${moment(directDiscount.active_at).format(
                    'DD/MM/YYYY'
                  )} - ${moment(directDiscount.expire_at).format(
                    'DD/MM/YYYY'
                  )}`}
                </span>
              ) : (
                <span>{directDiscount.day_discount}/hàng tuần</span>
              )}

              <br />

              <div className="title-detail-promotion">
                <b>Trạng thái kích hoạt:</b>
              </div>
              <span>
                {directDiscount.is_active
                  ? 'Đang kích hoạt'
                  : 'Không kích hoạt'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Ngày khởi tạo:</b>
              </div>
              <span>
                {directDiscount.create_at !== null
                  ? `${moment(directDiscount.create_at).format('DD/MM/YYYY')}`
                  : '---'}
              </span>
              <br />

              <div className="title-detail-promotion">
                <b>Ngày cập nhật (cuối cùng):</b>
              </div>
              <span>
                {directDiscount.update_at !== null
                  ? `${moment(directDiscount.update_at).format('DD/MM/YYYY')}`
                  : '---'}
              </span>
              <br />
            </ModalBody>
          )}
        </Modal>
      </div>
    );
  }
}
